import 'isomorphic-fetch';
import {Promise} from 'es6-promise';

Promise.polyfill();

import './assets/index';
import './components';

import './components/header/index';
import './components/footer/index';
import './components/form/index';
import './components/card-cta/index';
import './components/card-story/index';
import './components/featured-articles/index';
import './components/accordion-item/index';
import './components/contact-company/index';
import './components/hero/index';
import './components/video/index';
import './components/cta-banner/index';
import './components/list-view/index';
import './components/card-course/index';
import './components/text/index';
import './components/search-box/index';
import './components/in-page-nav/index';
import './components/variants-block/index';
import './components/cta-full-width/index';
import './components/card-author/index';
import './components/social-links/index';
import './components/contact-person/index';
import './components/social-share/index';
import './components/cookie-bar/index';
import './components/card-news/index';
import './components/card-event/index';
import './components/search-filter-result/index';
import './components/breadcrumb/index';
import "./components/cta-with-form/index";

//SHARED
import "../../shared/components/cookie-bar/index";

import './assets/app';
